import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import "./../../assets/css/Home.css";
import TourPackagesSlider from "./TourPackagesSlider";
import TourCards from "./TourCards";
import TravelDestinations from "./TravelDestinations";
import TravelSection from "./TravelSection";
import TravelSlider from "../../component/Banner/TravelSlider";
import axios from "axios";
import BASE_URL from "../../component/commanfile";

function Home({webTours, packages, hotPackages, homeImages}) {

 

  return (
    <div className="home-page">
      {/* Background Elements */}
      <div className="background-elements">
        <div className="bg-gradient"></div>
        <div className="bg-grid"></div>
        <div className="bg-shape bg-shape-1"></div>
        <div className="bg-shape bg-shape-2"></div>
        <div className="bg-shape bg-shape-3"></div>
        <div className="wave-decoration">
          <div className="wave"></div>
          <div className="wave"></div>
          <div className="wave"></div>
        </div>
      </div>

      {/* Main Content */}
      <div className="banner-wrapper">
        <TravelSlider homeImages={homeImages}/>
        <div className="featured-destinations-section">
          <Container>
            <TourPackagesSlider packages={hotPackages}/>
          </Container>
        </div>
      </div>

      <div className="tour-cards-wrapper">
        <TravelDestinations packages={packages}/>
      </div>
         <div className="tour-cards-wrapper">
        <TourCards tourSector={webTours}/>
      </div>
         <div className="tour-cards-wrapper">
        <TravelSection />
      </div>
    </div>
  );
}

export default Home;
